// extracted by mini-css-extract-plugin
module.exports = {"hidden":"kakaoShareButton_hidden__HSIh3","textEmphasis":"kakaoShareButton_textEmphasis__CiuL7","kakaoBtn":"kakaoShareButton_kakaoBtn__AOSgw"};